import React, { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { Empty } from "antd";

const RecenterMap = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    if (position && position[0] && position[1]) {
      map.setView(position, 13);
    }
  }, [position, map]);

  return null;
};

const MapComponent = ({
  name = "Unknown Location",
  latitude = 0,
  longitude = 0,
}) => {
  if (!latitude || !longitude || isNaN(latitude) || isNaN(longitude)) {
    return (
      <div
        style={{
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="No location data available" />
      </div>
    );
  }

  const position = [latitude, longitude];

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={false}
      style={{ height: "222px" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup>{name}</Popup>
      </Marker>
      <RecenterMap position={position} />
    </MapContainer>
  );
};

export default MapComponent;
